import { Step } from "@/interfaces/copilotTypes";
import React from "react";
import remarkGfm from "remark-gfm";
import {
  SearchIcon,
  ViewIcon,
  BookmarkIcon,
  ComputerIcon,
  ArrowUpDown,
} from "lucide-react";
import { MemoizedReactMarkdown } from "@/components/MemoizedReactMarkdown";

function ThoughtStep({ step }: { step: Step }) {
  function renderStepLogo() {
    switch (step.step_type) {
      case "doing":
        return <ComputerIcon size={14} />;
      case "observing":
        return <ViewIcon size={14} />;
      case "reading":
        return <BookmarkIcon size={14} />;
      case "searching":
        return <SearchIcon size={14} />;
      case "sorting":
      default:
        return <ArrowUpDown size={14} />;
    }
  }

  return (
    <div className="flex items-start py-0.5 text-[#A050FF]">
      <div className="pt-[2px]">{renderStepLogo()}</div>
      <MemoizedReactMarkdown
        remarkPlugins={[remarkGfm]}
        className="break-words pl-2"
        components={{
          a({ href, children, ...props }) {
            return (
              <a
                className="italic underline"
                href={href}
                rel="noreferrer"
                target={"_blank"}
                {...props}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {step.content}
      </MemoizedReactMarkdown>
    </div>
  );
}

export default ThoughtStep;
